export default __webpack_public_path__ + "static/media/cover_big.311ba4bf.jpg";